import { useId } from 'react';

export default function TextArea({
  label,
  instruction,
  error,
  id,
  name,
  value,
  onChange,
  required = false,
  disabled = false,
  maxLength,
  showCount = Boolean(maxLength),
  rows = 4,
  className = '',
  textareaClassName = '',
  ...props
}) {
  const generatedId = useId();
  const fieldId = id || name || `textarea-${generatedId}`;
  const instructionId = instruction ? `${fieldId}-instruction` : undefined;
  const errorId = error ? `${fieldId}-error` : undefined;
  const describedBy = [instructionId, errorId].filter(Boolean).join(' ') || undefined;

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label htmlFor={fieldId} className="mb-1.5 block text-sm font-medium">
          {label}
          {required && <span className="ml-1 text-error" aria-hidden="true">*</span>}
        </label>
      )}
      {instruction && (
        <p id={instructionId} className="mb-2 text-xs text-base-content/60">
          {instruction}
        </p>
      )}
      <textarea
        id={fieldId}
        name={name}
        className={`textarea textarea-bordered w-full ${error ? 'textarea-error' : ''} ${textareaClassName}`}
        rows={rows}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
        maxLength={maxLength}
        aria-invalid={error ? 'true' : 'false'}
        aria-describedby={describedBy}
        {...props}
      />
      <div className="mt-1 flex min-h-5 items-start justify-between gap-3 text-xs">
        {error ? (
          <p id={errorId} className="text-error" role="alert">{error}</p>
        ) : <span />}
        {showCount && (
          <span className="shrink-0 text-base-content/50" aria-live="polite">
            {(value || '').length}{maxLength ? ` / ${maxLength}` : ''}
          </span>
        )}
      </div>
    </div>
  );
}
